import React from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import get from 'lodash/get'
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Label,
  Input,
  CustomInput,
} from 'reactstrap'
import shortid from 'shortid'
import styled from 'styled-components'
import Select from 'react-select'
import { BeatLoader } from 'react-spinners'
import { customStyles, invalidStyles, leave_time, FONTS, COLORS } from '../../../constants'
import CustomButtonDate from './custom-datepicker'
import TrashHover from '../../../static/images/trash-hover.svg'

class LeaveRequestForm extends React.Component {
  render() {
    const newLeaveRequest = get(this.props, 'newLeaveRequest')
    const isCalendarDay = newLeaveRequest
    && newLeaveRequest.leave_type_id
    && newLeaveRequest.leave_type_id.is_calendar_day

    return (
      /* eslint no-underscore-dangle: 0 */
      <Modal
        isOpen={ get(this.props, 'showRequestForm') }
        toggle={ get(this.props, 'handleCloseRequest') }
      >
        <ModalHeader
          toggle={ get(this.props, 'handleCloseRequest') }
        >
          <HeadModal>Leave Request</HeadModal>
        </ModalHeader>
        <ModalBody>
          <LabelTextDate>
            Leave Type<span style={ { color: 'red' } }>*</span>
          </LabelTextDate>
          <Row noGutters>
            <Col>
              <SelectInputField
                styles={ get(newLeaveRequest, 'leave_type_id.leave_type_id') === undefined ? invalidStyles : customStyles }
                name="leave_type_id"
                placeholder="Enter Leave Type ID"
                value={ get(newLeaveRequest, 'leave_type_id') }
                options={ get(this.props, 'leaveTypeList') }
                onChange={ (e) => this.props.handleInputLeave('leave_type', e) }
              />
            </Col>
          </Row>
          <LabelTextDate>
            Leave Date<span style={ { color: 'red' } }>*</span>
          </LabelTextDate>
          <RowDate>
            <ColStart>
              <LeaveDatePicker
                autoComplete='off'
                onChange={ (e) => this.props.handleInputLeave('leave_start_date', e) }
                name="start_date"
                placeholderText='DD/MM/YYYY'
                selected={ get(newLeaveRequest, 'start_date') }
                dateFormat="DD/MM/YYYY"
                popperPlacement="bottom-start"
                showMonthDropdown
                showYearDropdown
                dropdownMode='select'
              />
            </ColStart>
            {'-'}
            <ColEnd>
              <LeaveDatePicker
                autoComplete='off'
                onChange={ (e) => this.props.handleInputLeave('leave_end_date', e) }
                name="end_date"
                placeholderText='DD/MM/YYYY'
                selected={ get(newLeaveRequest, 'end_date') }
                dateFormat="DD/MM/YYYY"
                popperPlacement="bottom-end"
                showMonthDropdown
                showYearDropdown
                dropdownMode='select'
              />
            </ColEnd>
          </RowDate>
          { /* date picker for mobile */ }
          <LabelTextMobile>
            Leave Date<span style={ { color: 'red' } }>*</span>
          </LabelTextMobile>
          <RowDateMobile>
            <LabelDate>Start Date : </LabelDate>
            <ColStartMobile>
              <LeaveDatePicker
                autoComplete='off'
                customInput={ <CustomButtonDate /> }
                onChange={ (e) => this.props.handleInputLeave('leave_start_date', e) }
                name="start_date"
                placeholderText='DD/MM/YYYY'
                selected={ get(newLeaveRequest, 'start_date') === '' ? '' : get(newLeaveRequest, 'start_date') }
                dateFormat="DD/MM/YYYY"
                popperPlacement="bottom-start"
                showMonthDropdown
                showYearDropdown
                dropdownMode='select'
              />
            </ColStartMobile>
            <LabelDate> Date : </LabelDate>
            <ColEndMobile>
              <LeaveDatePicker
                autoComplete='off'
                customInput={ <CustomButtonDate /> }
                onChange={ (e) => this.props.handleInputLeave('leave_end_date', e) }
                name="end_date"
                placeholderText='DD/MM/YYYY'
                selected={ get(newLeaveRequest, 'end_date') === '' ? '' : get(newLeaveRequest, 'end_date') }
                dateFormat="DD/MM/YYYY"
                popperPlacement="bottom-start"
                showMonthDropdown
                showYearDropdown
                dropdownMode='select'
              />
            </ColEndMobile>
          </RowDateMobile>
          { /* date picker for mobile */ }
          <LabelText>Leave Time</LabelText>
          <Row noGutters>
            <Col>
              <CustomInputField
                type="select"
                id="leave_time"
                name="leave_time"
                value={ get(newLeaveRequest, 'leave_time') }
                disabled={ isCalendarDay }
                onChange={ (e) => this.props.handleInputLeave('leave_time', e) }
              >
                {
                  leave_time.map((s) =>
                    <option key={ shortid() } value={ s.value }>{ s.label }</option>)
                }
              </CustomInputField>
            </Col>
          </Row>
          <LabelText>
            Approver<span style={ { color: 'red' } }>*</span>
          </LabelText>
          <Row noGutters>
            <Col>
              <SelectInputField
                styles={ get(newLeaveRequest, 'approver_id.approver_id') === undefined ? invalidStyles : customStyles }
                name="approver_id"
                value={ get(newLeaveRequest, 'approver_id') }
                options={ get(this.props, 'approverList') }
                onChange={ (e) => this.props.handleInputLeave('approver', e) }
              />
            </Col>
          </Row>
          <LabelText>Attachments</LabelText><TextMB>(Max 5 MB)</TextMB>
          <Row noGutters>
            <Col>
              <div style={ { display: 'flex', alignItems: 'center' } }>
                <ButtonUpload>Choose Files
                  <InputUpload id='fileUpload' type="file" onChange={ get(this.props, 'uploadFile') } />
                </ButtonUpload>
                <BeatLoader
                  sizeUnit={ "px" }
                  size={ 10 }
                  color={ '#D44B49' }
                  loading={ get(this.props, 'loading') }
                />
                <FileName href={ get(this.props, 'attachment_url') }>
                  { !get(this.props, 'loading') && get(this.props, 'filename') }
                </FileName>
                { !get(this.props, 'loading') && get(this.props, 'filename') &&
                  <Trash onClick={ () => {
                    document.getElementById('fileUpload').value = ''
                    get(this.props, 'removeFile')()
                  } }
                  /> }
              </div>
            </Col>
          </Row>
          <LabelText>Remarks</LabelText>
          <Row noGutters>
            <Col>
              <InputField
                name="remark"
                placeholder="Enter Remark"
                value={ get(newLeaveRequest, 'remark') }
                onChange={ (e) => this.props.handleInputLeave('remark', e) }
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter style={ { borderTop: 'none' } }>
          <CustomButton
            color="success"
            onClick={ get(this.props, 'validateLeaveRequest') }
          >Submit</CustomButton>
        </ModalFooter>
      </Modal>
    )
  }
}

LeaveRequestForm.propTypes = {
  handleInputLeave: PropTypes.func.isRequired,
}

export default LeaveRequestForm

const LabelTextDate = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
  margin-top: 2%;
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`
const LabelText = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
  margin-top: 2%;
`
const LabelTextMobile = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
  margin-top: 2%;
  @media (min-width: 576px) {
    font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
    margin-top: 2%;
  }
  @media (min-width: 768px) {
    font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
    margin-top: 2%;
  }
  @media (min-width: 992px) {
    display: none;
  }
  @media (min-width: 1200px) {
    display: none;
  }
`
const LabelDate = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: 12px ;
  margin-top: 0%;
  margin-bottom: 0% ;
  margin-left: 15px ;
  @media (min-width: 576px) {
    font-family: ${FONTS.GOTHAM_MEDIUM};
    font-size: 12px ;
    margin-top: 2%;
    margin-right: 10px ;
  }
  @media (min-width: 768px) {
    font-family: ${FONTS.GOTHAM_MEDIUM};
    font-size: 12px ;
    margin-top: 2%;
    margin-right: 10px ;
  }
  @media (min-width: 992px) {
    display: none;
  }
  @media (min-width: 1200px) {
    display: none;
  }
`
const FileName = styled.a`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
  padding-left: 2%;
  width: 50%;
  word-break: break-word;
`
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
  height: 40px;
  width: fit-content;
  padding-top: 0px;
  padding-bottom: 0px;
`
const HeadModal = styled.p`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  margin: 0px;
  color: ${COLORS.PRIMARY_RED};
  font-size: ${FONTS.TITLE_SIZE};
`
const TextMB = styled(Label)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  margin: 0px;
  padding-left: 2%;
`
const LeaveDatePicker = styled(DatePicker)`
  font-family: ${FONTS.GOTHAM} !important;
  width : 216px ;
  height : 30px ;
  font-size: ${FONTS.NORMAL_SIZE};
  padding-left: 5%;
  border-radius: 5px;
  border: ${props => {
    const status = props.selected
    if (status === undefined || status === null) {
      return '1px solid #D9534F'
    }
    return '1px solid #CCCCCC'
  }};
  @media (max-width: 575.98px) {
    width: 100%;
  }
`
const ColEnd = styled(Col)`
  padding-left: 2%;
  padding-right: 0%;
  width: 100%;
`
const ColEndMobile = styled(Row)`
  padding-right: 0%;
  padding-left: 10%;
  width: 100%;
`
const RowDate = styled(Row)`
  padding-right: 0%;
  margin-left: 0%;
  margin-right: 0%;
  width: 100%;
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`
const RowDateMobile = styled(Row)`
  @media (min-width: 576px) {
    padding-right: 0%;
    margin-left: 0%;
    margin-right: 0%;
    width: 100%;
  }
  @media (min-width: 768px) {
    padding-right: 0%;
    margin-left: 0%;
    margin-right: 0%;
    width: 100%;
  }
  @media (min-width: 992px) {
    display: none;
  }
  @media (min-width: 1200px) {
    display: none;
  }
`
const ColStart = styled(Col)`
  padding-right: 1%;
  padding-left: 0%;
  width: 100%;
`
const ColStartMobile = styled(Row)`
  padding-right: 0%;
  padding-left: 10%;
  width: 100%;
`
const SelectInputField = styled(Select)`
  font-family: ${FONTS.GOTHAM} !important;
  width : 100% ;
  height : 100% ;
  font-size: ${FONTS.NORMAL_SIZE};
`
const CustomInputField = styled(CustomInput)`
  font-family: ${FONTS.GOTHAM} !important;
  width : 100% ;
  height : 100% ;
  font-size: ${FONTS.NORMAL_SIZE};
`
const InputField = styled(Input)`
  font-family: ${FONTS.GOTHAM} !important;
  width : 100% ;
  height : 100% ;
  font-size: ${FONTS.NORMAL_SIZE};
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`
const InputUpload = styled.input`
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  font-size: 100px;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  cursor: inherit;
  display: block;
`
const ButtonUpload = styled(Button)`
  position: relative;
  overflow: hidden;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.NORMAL_SIZE};
  background-color:#428BCA;
  border: 1px solid #428BCA;
  width: 120px;
  height: 40px;
  cursor: pointer;
  padding-top: 0px;
  padding-bottom: 0px;
  margin-right: 5%;
  @media (max-width: 575.98px) {
    font-size: 12px;
    width: 40%;
  }
`
const Trash = styled.div`
  background-image: url(${TrashHover});
  background-repeat: no-repeat;
  align-self: center;
  border: 0;
  width: 20px;
  height: 20px;
  margin: auto;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/components/my-leave/form/leave.js